import React from 'react';

import './styles/Header.scss';
import logoImg from '../../images/logo.svg'
import MoreImg from '../ui/images/menuWhiteSVG'
// import menuIconImage from '../ui/images/menuWhiteSVG'


const Header = (props) => {
	let title = props.title;

	return (<header>
		<div className="mainHeader header-row">
			<div onClick={props.onOpenMenuClick} className="menu-icon link enabled" >
				<MoreImg />
			</div>
			<div className="md-title">{title}</div>
			<a href="/"><img src={logoImg} alt="SpecialT" /></a>
		</div>
	</header>)
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx